import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as fromConfig from './config/reducers/config.reducer';
import * as fromLocale from './locale/locale.reducer';
import * as fromBia from './bia/bia.reducer';
import { BiaState } from './bia/bia.state';
import * as fromSaBia from './sa-bia/sa-bia.reducer';
import { SaBiaState } from './sa-bia/sa-bia.state';
import * as fromSaResources from './sa-resources/sa-resources.reducer';
import { SaResourcesState } from './sa-resources/sa-resources.state';
import * as fromSaRa from './sa-ra/sa-ra.reducer';
import * as fromUser from './user/user.reducer';
import * as fromBcp from './bcp/bcp.reducer';
import { SaRaState } from './sa-ra/sa-ra.state';
import * as fromSatus from './status/status.reducer';
import * as fromWorkflow from './workflow/workflow.reducer';

export interface State {
  [fromConfig.configFeatureKey]: fromConfig.State;
  [fromLocale.localeFeatureKey]: fromLocale.State;
  [fromBia.biaFeatureKey]: BiaState;
  [fromSaBia.saBiaFeatureKey]: SaBiaState;
  [fromSaResources.saResourceFeatureKey]: SaResourcesState;
  [fromSaRa.SaRaFeatureKey]: SaRaState;
  [fromUser.userFeatureKey]: fromUser.State;
  [fromBcp.bcpFeatureKey]: fromBcp.State;
  [fromSatus.statusFeatureKey]: fromSatus.State;
  [fromWorkflow.workflowFeatureKey]: fromWorkflow.State;
}

export const reducers: ActionReducerMap<State> = {
  [fromConfig.configFeatureKey]: fromConfig.reducer,
  [fromLocale.localeFeatureKey]: fromLocale.reducer,
  [fromBia.biaFeatureKey]: fromBia.reducer,
  [fromSaBia.saBiaFeatureKey]: fromSaBia.reducer,
  [fromSaResources.saResourceFeatureKey]: fromSaResources.reducer,
  [fromSaRa.SaRaFeatureKey]: fromSaRa.reducer,
  [fromUser.userFeatureKey]: fromUser.reducer,
  [fromBcp.bcpFeatureKey]: fromBcp.reducer,
  [fromSatus.statusFeatureKey]: fromSatus.reducer,
  [fromWorkflow.workflowFeatureKey]: fromWorkflow.reducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? []
  : [];
